import { TFunction } from '@psyomics/ui-common';
import { SurveyJs } from '@psyomics/ui-components';

import {
  uploadReferralRequestSurveyAttachment,
  useDeleteReferralRequestSurveyAttachment,
  useGetReferralRequestSurveyAttachmentDownloadUrl,
} from '../hooks/use-survey-attachments';

type DeleteReferralRequestSurveyAttachment = ReturnType<typeof useDeleteReferralRequestSurveyAttachment>[1];
type GetReferralRequestSurveyAttachmentDownloadUrl = ReturnType<
  typeof useGetReferralRequestSurveyAttachmentDownloadUrl
>;

type CreateSurveyAttachmentHandlersProps = {
  deleteReferralRequestSurveyAttachment: DeleteReferralRequestSurveyAttachment;
  getReferralRequestSurveyAttachmentDownloadUrl: GetReferralRequestSurveyAttachmentDownloadUrl;
  referralApiUrl: string;
  referralRequestSurveyResponseId: string;
  t: TFunction;
};

const createSurveyAttachmentHandlers = ({
  deleteReferralRequestSurveyAttachment,
  getReferralRequestSurveyAttachmentDownloadUrl,
  referralApiUrl,
  referralRequestSurveyResponseId,
  t,
}: CreateSurveyAttachmentHandlersProps) =>
  SurveyJs.createSurveyAttachmentHandlers({
    deleteAttachment: async (attachmentId) => {
      const result = await deleteReferralRequestSurveyAttachment({ input: { attachmentId } });
      if (result.error) {
        throw result.error;
      }
    },
    getDownloadUrl: async (attachmentId) => {
      const result = await getReferralRequestSurveyAttachmentDownloadUrl({ input: { attachmentId } });
      return result.data?.getReferralRequestSurveyAttachmentDownloadUrl.url;
    },
    t,
    uploadFile: (file, questionName) =>
      uploadReferralRequestSurveyAttachment({ file, questionName, referralApiUrl, referralRequestSurveyResponseId }),
  });

export { createSurveyAttachmentHandlers };
